import { useEffect, useState } from "react";

// item 60: minimal in-page language switch.
// Sets `lang` attribute and toggles between English and Spanish. Wires up to a
// real translation pipeline later — for now a UI placeholder hooked to localStorage
// so the user's choice persists across reloads.
const LANGS = [
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
] as const;

const STORAGE_KEY = "ocoee.lang";

export function LangSwitch() {
  const [lang, setLang] = useState<"en" | "es">("en");

  useEffect(() => {
    const saved = (typeof localStorage !== "undefined" && localStorage.getItem(STORAGE_KEY)) as
      | "en"
      | "es"
      | null;
    if (saved === "en" || saved === "es") setLang(saved);
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
    if (typeof localStorage !== "undefined") localStorage.setItem(STORAGE_KEY, lang);
  }, [lang]);

  return (
    <div className="lang-switch" role="group" aria-label="Language">
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          className={lang === l.code ? "is-active" : ""}
          aria-pressed={lang === l.code}
          onClick={() => setLang(l.code as "en" | "es")}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
